package com.dignicate.web.data.content.static.home

import com.dignicate.web.data.content.HeroContentDto
import com.dignicate.web.domain.Language
import com.dignicate.web.domain.LocalizedText
import com.dignicate.web.domain.LocalizedTexts

class HeroContentSource {
    fun hero(): HeroContentDto {
        return HeroContentDto(
            title = LocalizedTexts(
                listOf(
                    LocalizedText(
                        Language.Ja,
                        "モバイルアプリで、サービスを次のステージへ"
                    ),
                    LocalizedText(
                        Language.En,
                        "Level up your product with mobile apps"
                    )
                )
            ),
            subtitle = LocalizedTexts(
                listOf(
                    LocalizedText(
                        Language.Ja,
                        "Kotlin Multiplatform・Flutter・ネイティブ開発を軸に、スマートフォンアプリの設計から実装・運用まで、少人数で丁寧に並走します。"
                    ),
                    LocalizedText(
                        Language.En,
                        "We design and build mobile applications with Kotlin Multiplatform, Flutter, and native technologies  — from architecture to implementation and long-term operation."
                    )
                )
            )
        )
    }
}
